// i18n area 'cluster' — locale en-GB (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da cluster.en-US.ts e sovrascrive SOLO le chiavi
// che l'inglese britannico scrive davvero in un altro modo — una chiave nuova
// nella base arriva qui gratis, e la parità si misura su base + delta.
// Contenuto: ortografia britannica (-ise/-isation, 'licence' sostantivo,
// 'catalogue', 'centre', 'enrolment') e le poche differenze lessicali reali.
// Token che NON sono prosa (il riferimento catalog/<catalog>/<file>@<digest>,
// il permesso catalog.download) restano tali e quali.
// Sidecar anti-stantie: ../meta/cluster.en-GB.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './cluster'

export const enGB: DeepPartial<typeof enUS> = {
  cluster: {
    overlaysBehind: 'The overlay dataplane has not yet realised the current overlay configuration'
  },
  clusterDevices: {
    noRegsHint: 'No registration yet — mark the device as usable by TVirt from the node dialogue (Nodes › node › Settings).',
    manageOnNode: 'Manage on node {node} (marking lives in the node dialogue)',
    introStep2: '2. You mark a device as usable by TVirt from the NODE dialogue (Nodes › node › Settings) — that binds it to vfio and registers it here.'
  },
  localSettings: {
    placementLevel: {
      datacenter: 'Data centre'
    },
    cablingHint: 'One cable per NIC, one cable per port fleet-wide (the API refuses naming the holder). Cabling towards a LAGG-member port is legal — that is the bond case: the future derivation renders it as LACP.',
    dataDisksHint: 'Ticking a device declares it usable as an OSD; the serial is its identity pin — copied from the hardware when the device reports one, minted (tvirt-…) otherwise. The Ceph register dialogue offers only declared disks.'
  }
}
